<div class="wrap">
  <div class="increment-btn" [ngStyle]="{
      'height': themeConfig?.height,
      'color': themeConfig?.textColor,
      'border': themeConfig?.border,
      'background': themeConfig?.bgColor
    }">
    <button class="minus" (click)="remove()" [ngClass]="{'min': min===labelCount}" [disabled]="min===labelCount" mat-ripple>
      <em class="material-icons" [ngStyle]="{'font-size': themeConfig?.iconSize, 'color': themeConfig?.textColor}">remove</em>
    </button>
    <div class="label" [ngStyle]="{
        'font-size': themeConfig?.fontSize,
        'letter-spacing': themeConfig?.letterSpacing
      }">
      <span *ngIf="currency_symbol" [innerHTML]="currency_symbol"></span>{{labelCount}}
    </div>
    <button class="plus" (click)="add()" [ngClass]="{'max': max===labelCount}" [disabled]="max===labelCount" mat-ripple>
      <em class="material-icons" [ngStyle]="{'font-size': themeConfig?.iconSize, 'color': themeConfig?.textColor}">add</em>
    </button>
  </div>
</div>